export const getWebsiteImagesStyles = () => ({
  subdomainFields: {
    marginTop: 16,
    marginBottom: 16,
    '& .divider': {
      display: 'inline-block',
      marginLeft: 10,
      marginRight: 10,
      fontSize: 14,
      lineHeight: '20px',
    },
  },
  textAbovePicker: {
    display: 'block',
    margin: 12,
  },
  rootContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
});

export const websiteImagesFinalUrlTextFieldStyles = {
  root: {
    display: 'inline-block',
    width: 260,
  },
  field: {
    paddingRight: 8,
    paddingLeft: 32,
  },
};

export const websiteImagesFinalUrlTextFieldIconProps = {
  iconName: 'Search',
  styles: {
    root: {
      left: 8,
      right: 0,
    },
  },
};

export const websiteImagesSubdomainTextFieldStyles = {
  root: {
    display: 'inline-block',
    width: 260,
  },
};
